var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"anchor",attrs:{"id":"back-top"},on:{"click":function($event){$event.preventDefault();return _vm.backToTop.apply(null, arguments)}}},[_c('img',{attrs:{"src":"/img/common/back-top.png","alt":"back-top"}})])}
var staticRenderFns = []

export { render, staticRenderFns }